import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';
import { ImageUIComponent } from '../image/image.component';
import { LoadingUIComponent } from '../loading/loading.component';
import { AvatarUploaderSizeType } from '../../../types/avatar-uploader.type';

const DEFAULT_AVATAR_UPLOADER_SIZE: AvatarUploaderSizeType = 80;

@Component({
  selector: 'fr8bot-ui-avatar-uploader',
  imports: [LoadingUIComponent, IconUIComponent, ImageUIComponent],
  templateUrl: './avatar-uploader.component.html',
  styleUrl: './avatar-uploader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarUploaderUIComponent {
  readonly size = input<AvatarUploaderSizeType>(DEFAULT_AVATAR_UPLOADER_SIZE);
  readonly disabled = input(false);
  readonly src = input<string>();
  readonly loading = input(false);
}
